import { UntilDestroy } from '@ngneat/until-destroy'
import { Component, input, model } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionModule } from '@angular/material/expansion'
import { TranslocoModule } from '@jsverse/transloco'
import { TbAccordionComponent } from '@components-library/tb-accordion/tb-accordion.component'
import { TbTab } from '@components-library/tb-tab/tb-tab.component'
import { FieldEntities, Schema, WorkspaceViewRecord } from '@core/models'
import { StatusSectionComponent } from '@app/feature/header/workspace-controls/advanced-options/status-section/status-section.component'
import { FieldSectionComponent } from '@app/feature/header/workspace-controls/advanced-options/field-section/field-section.component'
import { ViewSectionComponent } from '@app/feature/header/workspace-controls/advanced-options/view-section/view-section.component'

@UntilDestroy()
@Component({
    selector: 'app-advanced-options',
    templateUrl: './advanced-options.component.html',
    imports: [
        TranslocoModule,
        MatExpansionModule,
        MatIconModule,
        TbAccordionComponent,
        StatusSectionComponent,
        FieldSectionComponent,
        ViewSectionComponent,
    ],
})
export class AdvancedOptionsComponent {
    readonly schemaTabs = input.required<TbTab[]>()
    readonly templateSchemas = model.required<Schema[]>()
    readonly templateViews = model.required<WorkspaceViewRecord>()
    readonly fieldsBySchema = model.required<Record<string, FieldEntities>>()
    readonly inactiveFields = model<string[]>([])
    expanded = true

    protected updateTemplateFields(fields: Record<string, FieldEntities>) {
        this.fieldsBySchema.set(fields)
    }
    protected updateTemplateSchemas(schemas: Schema[]) {
        this.templateSchemas.set(schemas)
    }

    protected updateInactiveFields(guids: string[]) {
        this.inactiveFields.set(guids)
    }

    protected updateTemplateViews(views: WorkspaceViewRecord) {
        this.templateViews.set(views)
    }
}
